import apiClient from '../lib/apiClient';

export interface BitrixAllowedDomain {
  id: number;
  domain: string;
  clientName: string | null;
  notes: string | null;
  isEnabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateBitrixAllowedDomainDto {
  domain: string;
  clientName?: string;
  notes?: string;
}

export interface UpdateBitrixAllowedDomainDto {
  domain?: string;
  clientName?: string;
  notes?: string;
  isEnabled?: boolean;
}

class BitrixAllowedDomainService {
  // Admin endpoint (backoffice)
  async getAll(): Promise<BitrixAllowedDomain[]> {
    const data = await apiClient.get('/backoffice/bitrix-allowed-domains');
    return data as BitrixAllowedDomain[];
  }

  // Admin endpoint (backoffice)
  async create(data: CreateBitrixAllowedDomainDto): Promise<BitrixAllowedDomain> {
    const response = await apiClient.post('/backoffice/bitrix-allowed-domains', data);
    return response as BitrixAllowedDomain;
  }

  // Admin endpoint (backoffice)
  async update(id: number, data: UpdateBitrixAllowedDomainDto): Promise<BitrixAllowedDomain> {
    const response = await apiClient.put(`/backoffice/bitrix-allowed-domains/${id}`, data);
    return response as BitrixAllowedDomain;
  }

  // Admin endpoint (backoffice)
  async delete(id: number): Promise<{ message: string }> {
    const response = await apiClient.delete(`/backoffice/bitrix-allowed-domains/${id}`);
    return response as { message: string };
  }
}

export const bitrixAllowedDomainService = new BitrixAllowedDomainService();
